export enum FunctionTypes {
    Message      = 1,
    Report       = 2,
    Grade        = 4,
    EntryAndExit = 8,
    Reserve      = 16,
    Chat         = 32,
    Bill         = 64,
}
